import React, { Component } from 'react';
import { Button } from 'reactstrap';
import RFField from '../../../components/Form/RFField';

class Mezo extends Component {
  render() {
    return (
      <div className="col-md-12">
        <div className="row">
          <div className="col-md">
            <RFField
              label={this.props.mezonev}
              name={this.props.mezonev}
              value={this.props.tartalom}
              onChange={this.props.updateMeta}
            />
          </div>
            <div style={{ alignSelf: 'center', marginTop: '12px' }} className="col-md-auto">
              <Button type="button" id="torles" className="btn-cursor-pointer" color="danger" onClick={this.props.delete.bind(this, this.props.mezonev)}><i className="fa fa-trash" /></Button>
            </div>
        </div>
      </div>
    );
  }
}

export default Mezo;
